import type { ProductLogoMediumProps } from '../types';

export function ProductLogoMediumPublicIDs({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 672 672"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="672" height="672" rx="100" fill="#1A2142" />
      <path
        d="M300.94 288C300.94 314.51 279.45 336 252.94 336C226.431 336 204.94 314.51 204.94 288C204.94 261.49 226.431 240 252.94 240C279.45 240 300.94 261.49 300.94 288Z"
        fill="#57D7D9"
      />
      <path
        d="M168.94 408C168.94 381.49 190.431 360 216.94 360H288.94C315.45 360 336.94 381.49 336.94 408V424C336.94 428.418 333.358 432 328.94 432H176.94C172.522 432 168.94 428.418 168.94 424V408Z"
        fill="#57D7D9"
      />
      <path
        d="M372.94 276C372.94 269.373 378.313 264 384.94 264H480.94C487.568 264 492.94 269.373 492.94 276C492.94 282.627 487.568 288 480.94 288H384.94C378.313 288 372.94 282.627 372.94 276Z"
        fill="white"
      />
      <path
        d="M372.939 336C372.939 329.373 378.312 324 384.939 324H480C486.627 324 492 329.373 492 336C492 342.627 486.627 348 480 348H384.939C378.312 348 372.939 342.627 372.939 336Z"
        fill="white"
      />
      <path
        d="M372.939 396C372.939 389.373 378.312 384 384.939 384H480C486.627 384 492 389.373 492 396C492 402.627 486.627 408 480 408H384.939C378.312 408 372.939 402.627 372.939 396Z"
        fill="white"
      />
      <path
        d="M120 192C120 178.745 130.745 168 144 168V192H120Z"
        fill="white"
      />
      <path
        d="M526.898 168C540.153 168 550.898 178.745 550.898 192H526.898V168Z"
        fill="white"
      />
      <path
        d="M120 480H144V504C130.745 504 120 493.255 120 480Z"
        fill="white"
      />
      <path
        d="M526.898 504V480H550.898C550.898 493.255 540.153 504 526.898 504Z"
        fill="white"
      />
      <path d="M144 168H526.898V192H144V168Z" fill="white" />
      <path d="M144 480H526.898V504H144V480Z" fill="white" />
      <path d="M120 192H144L144 480H120L120 192Z" fill="white" />
      <path d="M526.898 192H550.898V480H526.898V192Z" fill="white" />
    </svg>
  );
}
